/**
 * Customizes Clerk modals to replace "organization" with "workspace" terminology
 * and hide the slug field
 */
export function initializeClerkModalCustomizer() {
  // Function to hide slug field and update text
  const customizeModal = () => {
    // Hide slug field and its container
    const slugSelectors = [
      '[data-localization-key*="organizationSlug"]',
      '[id*="organizationSlug"]',
      '[name*="organizationSlug"]',
      'input[name="slug"]',
      'label[for*="slug"]',
      'div:has(> input[name="slug"])',
      'div:has(> label[for*="slug"])',
      '.cl-formFieldRow__organizationSlug',
      '.cl-formField__organizationSlug',
    ];

    slugSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        if (el instanceof HTMLElement) {
          el.style.display = 'none';
          el.style.visibility = 'hidden';
          el.style.height = '0';
          el.style.overflow = 'hidden';
          el.style.position = 'absolute';
          el.style.left = '-9999px';
        }
      });
    });

    // Find the slug field container by looking for the "Slug" label
    const labels = document.querySelectorAll('label');
    labels.forEach(label => {
      if (label.textContent?.trim() === 'Slug') {
        // Hide the label
        label.style.display = 'none';

        // Find and hide the parent container
        let parent = label.parentElement;
        while (parent && parent !== document.body) {
          // Check if this is the field container
          const hasInput = parent.querySelector('input[name="slug"], input[id*="slug"]');
          if (hasInput) {
            parent.style.display = 'none';
            break;
          }
          parent = parent.parentElement;
        }
      }
    });

    // Replace "Organization name" placeholder with "Workspace name"
    const inputs = document.querySelectorAll('input[placeholder="Organization name"]');
    inputs.forEach(input => {
      if (input instanceof HTMLInputElement) {
        input.placeholder = 'Workspace name';
      }
    });

    // Replace "Create organization" button text with "Create workspace"
    const buttons = document.querySelectorAll('button');
    buttons.forEach(button => {
      if (button.textContent?.trim() === 'Create organization') {
        button.textContent = 'Create workspace';
      }
    });

    // Replace any remaining "organization" text with "workspace" (case-insensitive)
    const textNodes: Node[] = [];
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: node => {
        const text = node.nodeValue?.toLowerCase() || '';
        if (
          text.includes('organization') &&
          !node.parentElement?.closest('script, style, [data-clerk-secured]')
        ) {
          return NodeFilter.FILTER_ACCEPT;
        }
        return NodeFilter.FILTER_REJECT;
      },
    });

    let node;
    while ((node = walker.nextNode()) !== null) {
      textNodes.push(node);
    }

    textNodes.forEach(node => {
      if (node.nodeValue) {
        node.nodeValue = node.nodeValue
          .replace(/Organization/g, 'Workspace')
          .replace(/organization/g, 'workspace');
      }
    });
  };

  // Set up MutationObserver to watch for Clerk modal changes
  const observer = new MutationObserver(mutations => {
    // Check if any Clerk modal elements were added
    const hasClerkModal = mutations.some(mutation => {
      return Array.from(mutation.addedNodes).some(node => {
        if (node instanceof HTMLElement) {
          return node.classList?.toString().includes('cl-') || node.querySelector('[class*="cl-"]');
        }
        return false;
      });
    });

    if (hasClerkModal) {
      // Delay to ensure modal is fully rendered
      setTimeout(customizeModal, 100);
      // Run again after a short delay to catch any late-rendering elements
      setTimeout(customizeModal, 300);
    }
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Also run on initial load in case modal is already present
  customizeModal();

  // Run periodically to catch any dynamic updates
  setInterval(customizeModal, 1000);

  return observer;
}
